var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ra-summary-card',{attrs:{"label":"Total Verification Requests","value":_vm.totalRequests}})
}
var staticRenderFns = []

export { render, staticRenderFns }